/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";

/* Styles */
import styles from "./styles.js";

const LoyaltyContentSkeleton = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.skeletonWrapper}>
      <div className={classes.outerContainer}>
        {/* Top Section: Loyalty Header */}
        <div className={classes.loyaltyHeader}>
          <Skeleton width="15%" height={24} className={classes.loyaltyTitle} />
          <Skeleton width="10%" height={18} className={classes.loyaltySubtext} />
          <div className={classes.pointsTable}>
            <Skeleton circle={true} height={40} width={40} />
            <div className={classes.tableRowDetails}>
              <Skeleton width="15%" height={16} />
              {/* Progress Bar */}
              <div className={classes.progressBarWrapper}>
                <Skeleton width="80%" height={20} />
              </div>
              <Skeleton width="15%" height={14} />
            </div>
            <Skeleton width="15%" height={16} />
          </div>
          <div className={classes.redeemButtonContainer}>
            <Skeleton height={40} className={classes.redeemButton} />
          </div>
        </div>
      </div>

      {/* Redemption History Section */}
      <div className={classes.outerContainer}>
        <div className={classes.redemptionHistoryHeader}>
          <div className={classes.redemptionHistoryHeaderLeft}>
            <Skeleton width="15%"></Skeleton>
            <Skeleton width="25%"></Skeleton>
          </div>
          <div className={classes.redemptionHistoryHeaderRight}>
            <Skeleton width="110px" height={40}></Skeleton>
          </div>
        </div>
        <div className={classes.redemptionHistoryHeader2}>
          <div className={classes.redemptionHistoryHeaderLeft2}>
            <Skeleton width="25%" height={40}></Skeleton>
          </div>
          <div className={classes.redemptionHistoryHeaderRight2}>
            <Skeleton width="400px" height={40}></Skeleton>
          </div>
        </div>
        <div className={classes.redemptionHistory}>
          <div className={classes.sectionTitle}>
            <Skeleton height={24} />
          </div>
          <div className={classes.tableSkeleton}>
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className={classes.tableRow}>
                <Skeleton circle={true} height={40} width={40} />
                <div className={classes.tableRowDetails}>
                  <Skeleton width="60%" height={16} />
                  <Skeleton width="40%" height={14} />
                </div>
                <Skeleton width="15%" height={16} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyContentSkeleton;